if (loschlegal.posts_by_tax && Object.keys(loschlegal.posts_by_tax).length > 0) {
    const containerFAQ = document.querySelector('.horizon-faq__inner');
    
    if (containerFAQ) {
        Object.keys(loschlegal.posts_by_tax).forEach((termId) => {
            const group = loschlegal.posts_by_tax[termId]; // Get the post group for each term_id
            const firstPost = group[0]; // Get the first post of the group
            const termName = firstPost ? firstPost.term_name : termId; // Get term_name or fallback to termId

            const item = document.createElement('div');
            item.className = 'horizon-faq__item';

            const question = document.createElement('div');
            question.className = 'horizon-faq__question';
            question.innerHTML = `${termName}`;
            const icon = document.createElementNS("http://www.w3.org/2000/svg", "svg");
            icon.setAttribute("width", "17");
            icon.setAttribute("height", "11");
            icon.setAttribute("viewBox", "0 0 17 11");
            icon.setAttribute("fill", "none");
            icon.setAttribute("xmlns", "http://www.w3.org/2000/svg");
            icon.classList.add("horizon-faq__icon");

            const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
            path.setAttribute("fill-rule", "evenodd");
            path.setAttribute("clip-rule", "evenodd");
            path.setAttribute(
                "d",
                "M9.14354 9.94688C8.85064 10.2398 8.37584 10.2398 8.08294 9.94688L0.436464 2.30038C0.143574 2.00748 0.143574 1.53268 0.436464 1.23978L0.790024 0.886179C1.08291 0.593279 1.55778 0.593279 1.85068 0.886179L8.61324 7.64878L15.3758 0.88618C15.6687 0.59328 16.1435 0.59328 16.4364 0.88618L16.79 1.23978C17.0829 1.53268 17.0829 2.00748 16.79 2.30038L9.14354 9.94688Z"
            );
            path.setAttribute("fill", "#7A7A7A");

            icon.appendChild(path);
            question.appendChild(icon);
            item.appendChild(question);

            const answer = document.createElement('div');
            answer.className = 'horizon-faq__answer';

            group.forEach((post) => {
                const linkWrap = document.createElement('div');
                linkWrap.className = 'horizon-faq__link-wrap';

                const link = document.createElement('a');
                link.className = 'horizon-faq__link';
                link.href = `/wiki/${post.post_name}`;
                link.textContent = post.post_title;

                const arrowIcon = document.createElementNS("http://www.w3.org/2000/svg", "svg");
                arrowIcon.setAttribute("width", "30");
                arrowIcon.setAttribute("height", "24");
                arrowIcon.setAttribute("viewBox", "0 0 30 24");
                arrowIcon.setAttribute("fill", "none");
                arrowIcon.setAttribute("xmlns", "http://www.w3.org/2000/svg");
                arrowIcon.classList.add("icon", "icon-arrow-left");

                const arrowPath = document.createElementNS("http://www.w3.org/2000/svg", "path");
                arrowPath.setAttribute("d", "M1.99935 12L28.666 12M28.666 12L18.666 22M28.666 12L18.666 2");
                arrowPath.setAttribute("stroke", "#F5F5F5");
                arrowPath.setAttribute("stroke-width", "2.3");
                arrowPath.setAttribute("stroke-linecap", "round");
                arrowPath.setAttribute("stroke-linejoin", "round");

                arrowIcon.appendChild(arrowPath);

                linkWrap.appendChild(link);
                linkWrap.appendChild(arrowIcon);
                answer.appendChild(linkWrap);
            });

            item.appendChild(answer);
            containerFAQ.appendChild(item);
        });
    }
}

const toggleFaq1 = (element) => {
    const answer = element.nextElementSibling;
    const answerHeight = answer.scrollHeight;

    if (answer.style.maxHeight) {
        answer.style.maxHeight = null;
        answer.style.padding = "0 0 0 0";
    } else {
        answer.style.maxHeight = answerHeight + "px";
        answer.style.padding = "0 0 0 0";
    }

    element.classList.toggle('active');
}

const faqs1 = document.querySelectorAll('.horizon-faq__question');
if( faqs1) {
    faqs1.forEach( faq => {
        faq.addEventListener( 'click', (e) => {
            toggleFaq1(e.target);
        })
    })
}